module.exports = new __parcel__URL__("product-requirements-dark.ac25b817.svg").toString();